import { useQuery } from "@tanstack/react-query";
import { getReportKpis } from "../../api/apiReports";

export const useGetReportKpis = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["report-kpis", params],
        queryFn: () => getReportKpis(params),
        retry: false,
    });

    return {
        kpis: data?.data || null,
        isLoading,
        error,
        refetch,
    };
};
